import { render, staticRenderFns } from "./add-items.vue?vue&type=template&id=a1d41570"
import script from "./add-items.vue?vue&type=script&lang=js"
export * from "./add-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports